module.exports = __webpack_public_path__ + "fonts/sole.ba843cb.ttf";